<div [hidden]="operationType" class="mt-3">
  <h2
    role="button"
    (click)="isTableCollapsed = !isTableCollapsed"
    tabindex="0"
    class="mb-0 py-2 p-3 rounded bg-light cursor-pointer"
  >
    <i
      class="fa h4 fa-fw"
      attr.aria-label="{{ 'general.toggle' | translate }}"
      role="img"
      [ngClass]="isTableCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
    ></i>
    {{ 'bookingModule.participants' | translate }}
  </h2>

  <div class="table-responsive" [hidden]="isTableCollapsed">
    <table class="table table-sm bg-white">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col" id="h-type">{{ 'general.type' | translate }}</th>
          <th scope="col" id="h-resource">{{
            'productModule.resource' | translate
          }}</th>
        </tr>
      </thead>
      <tbody *ngIf="participants$ | async">
        <tr *ngFor="let participant of participants$ | async">
          <th scope="row" id="h-p-id">{{ participant.id }}</th>
          <td headers="h-type h-p-id">
            {{
              'participationModule.participationType' + participant?.type
                | translate
            }}
          </td>
          <td headers="h-resource h-p-id">
            {{
              (productEntities$ | async)[
                (bookingEntities$ | async)[participant.bookingId]?.productId
              ]?.description
            }}
            <span
              class="badge bg-soft-warning"
              *ngIf="getIsOverBooked(participant) | async"
            >
              {{ 'bookingModule.overbooked' | translate }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <h2 class="mt-3">{{ 'bookingModule.adjustParticipants' | translate }}</h2>
  <div class="row justify-content-center row-cols-md-2 row-cols-lg-3">
    <div class="col" [hidden]="isBookingFull$() | async">
      <button
        type="button"
        (click)="operationType = 'add'"
        class="h-100 btn btn-ghost-primary text-body"
      >
        <span class="text-center mx-3 d-block">
          <i
            role="img"
            class="fa fa-user-plus fa-2x text-primary"
            aria-hidden="true"
          ></i>
        </span>
        <span class="text-center mx-3 d-block">
          <small class="text-cap">
            {{ 'saleModule.addParticipants' | translate }}
          </small>
        </span>
        <span class="text-center mx-3 d-block">
          {{ 'saleModule.addParticipantsSubtext' | translate }}
        </span>
      </button>
    </div>

    <div class="col">
      <button
        type="button"
        (click)="operationType = 'delete'"
        class="h-100 btn btn-ghost-primary text-body"
      >
        <span class="text-center mx-3 d-block">
          <i
            role="img"
            class="fa fa-user-minus fa-2x text-primary"
            aria-hidden="true"
          ></i>
        </span>
        <span class="text-center mx-3 d-block">
          <small class="text-cap">
            {{ 'saleModule.removeParticipants' | translate }}</small
          >
        </span>
        <span class="text-center mx-3 d-block">
          {{ 'saleModule.removeParticipantsParticipants' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>

<div [hidden]="!operationType">
  <form [formGroup]="form" class="border-top mb-3 py-3">
    <ng-container
      formArrayName="participantRows"
      *ngIf="participantRows?.length"
    >
      <div
        class="row row-cols-md-3 row-cols-lg-6 g-2 mb-2"
        *ngFor="let _ of participantRows.controls; index as i"
      >
        <ng-container [formGroupName]="i">
          <product-select-input
            [isDisabled]="operationType != 'add'"
            [products]="parentBookableProducts$ | async"
            formControlName="targetProductId"
            [allowClearing]="false"
            class="col-md-2 px-0"
          ></product-select-input>

          <select class="form-select" formControlName="type" hidden>
            <option [ngValue]="2" selected>
              {{ 'participationModule.participationType2' | translate }}
            </option>
            <option [ngValue]="3" selected>
              {{ 'participationModule.participationType3' | translate }}
            </option>
          </select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              participantRowsFormGroupAt(i).controls.targetProductId.dirty &&
              participantRowsFormGroupAt(i).controls.targetProductId.invalid
            "
          >
            {{ 'general.targetProductId' | translate }}
            {{ 'general.invalid' | translate }}
          </p>

          <div class="col">
            <select
              class="form-select"
              formControlName="type"
              [attr.disabled]="operationType != 'add' ? true : null"
            >
              <option [ngValue]="2" selected>
                {{ 'participationModule.participationType2' | translate }}
              </option>
              <option [ngValue]="3" selected>
                {{ 'participationModule.participationType3' | translate }}
              </option>
            </select>
          </div>
          <div [hidden]="operationType != 'delete'" class="col">
            <button
              type="button"
              [hidden]="
                participantRowsFormGroupAt(i).controls.action.value == 'delete'
              "
              (click)="onDeleteRow(i)"
              class="btn btn-sm btn-warning"
            >
              {{ 'general.delete' | translate }}
            </button>
            <button
              type="button"
              [hidden]="
                participantRowsFormGroupAt(i).controls.action.value !== 'delete'
              "
              (click)="onRestoreRow(i)"
              class="btn btn-sm btn-soft-primary"
            >
              {{ 'general.restore' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div class="my-3">
      <button
        type="button"
        *ngIf="!(isBookingFull$() | async)"
        class="btn btn-soft-primary btn-sm"
        (click)="addNewRow()"
        [hidden]="operationType != 'add'"
      >
        <i role="img" class="fa fa-plus-circle" aria-hidden="true"></i>
        {{ 'general.addRow' | translate }}
      </button>
    </div>
  </form>
</div>
